import { html } from 'lit';
import { Bell } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-bell')
export class PdsIconBell extends PdsIcon {
  @state()
  icon = Bell;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
